(function(){
  "use strict";

  // Scope every lookup to the widget root so this script never
  // touches — or collides with ids in — the rest of the host page.
  var root = document.getElementById("soReturnWidget");
  function $(id){ return root.querySelector("#" + id); }

  // ---- Backend endpoints (PHP) ----
  // These files are cross-origin from the Shopify storefront (they run
  // on demo.extnbakers.com), so API_BASE must be an absolute URL, not
  // a relative path — a relative "/api" would resolve against the
  // Shopify domain and 404.
  var API_BASE = "https://api.suppliesoutlet.com/ShopifyApp/Zohocode";
  var GET_ORDER_URL = API_BASE + "/get-order-by-id.php";   // GET  ?order=<shopify_order_id>
  var FIND_ORDER_URL = API_BASE + "/find-order.php";        // POST { order_number, email }
  var SUBMIT_URL = API_BASE + "/submit-return.php";         // POST multipart/form-data

  // ---- Attachment config ----
  var MAX_FILES = 5;
  var MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
  var ALLOWED_TYPES = ["image/png", "image/jpeg", "image/webp", "application/pdf"];

  var selectedFiles = []; // File objects currently staged for upload

  var state = { order: null, orderNumber: "" };

  var panels = { 1: $("soretPanel1"), 2: $("soretPanel2"), 3: $("soretPanel3") };
  var steps = root.querySelectorAll(".so-step");
  var line1 = $("soretLine1"), line2 = $("soretLine2");
  var cardHead = $("soretCardHead");

  function goToStep(n){
    Object.keys(panels).forEach(function(k){
      panels[k].classList.toggle("so-active", Number(k) === n);
    });
    steps.forEach(function(s){
      var sn = Number(s.getAttribute("data-step"));
      s.classList.toggle("so-active", sn === n);
      s.classList.toggle("so-done", sn < n);
    });
    line1.classList.toggle("so-done", n > 1);
    line2.classList.toggle("so-done", n > 2);
    cardHead.textContent = n === 1 ? "RETURN AUTHORIZATION" : (n === 2 ? "ORDER " + state.orderNumber : "REQUEST STATUS");
    root.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  // ---------- Validation helpers ----------
  function setInvalid(fieldId, invalid){
    $(fieldId).classList.toggle("so-invalid", invalid);
  }
  function showBanner(bannerId, html){
    var b = $(bannerId);
    b.innerHTML = html;
    b.classList.add("so-show");
  }
  function hideBanner(bannerId){
    $(bannerId).classList.remove("so-show");
  }

  var ORDER_NUM_RE = /^#?\d{2,}$/;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var PHONE_RE = /^[\d\s().+-]{7,20}$/;

  // ---------- STEP 1: Find order ----------
  var findForm = $("soretFindForm");
  var findFormWrap = $("soretFindFormWrap");
  var autoLoading = $("soretAutoLoading");
  var findBtn = $("soretFindBtn");

  function setAutoLoading(loading){
    autoLoading.style.display = loading ? "block" : "none";
    findFormWrap.style.display = loading ? "none" : "block";
  }

  // Case A: arrived from the logged-in "Return Items" button with
  // ?order=<shopify_order_id> already in the URL — skip straight to
  // a server lookup by order ID, no email confirmation needed.
  function getOrderIdFromUrl(){
    var params = new URLSearchParams(window.location.search);
    return params.get("order");
  }

  function autoLoadOrderById(orderId){
    setAutoLoading(true);
    fetch(GET_ORDER_URL + "?order=" + encodeURIComponent(orderId))
      .then(function(res){ return res.json(); })
      .then(function(payload){
        setAutoLoading(false);
        if (!payload.success){
          showBanner("soretFindErrorBanner", payload.message ||
            "We couldn't load that order automatically. Please enter your order number and email below.");
          return;
        }
        state.order = payload.order;
        state.orderNumber = payload.order.order_number;
        populateStep2(payload.order.order_number, payload.order);
        goToStep(2);
      })
      .catch(function(){
        setAutoLoading(false);
        showBanner("soretFindErrorBanner",
          "We couldn't load that order automatically. Please enter your order number and email below.");
      });
  }

  // Case B: no order id in the URL — guest enters order number + email,
  // and the server verifies the two match before releasing details.
  findForm.addEventListener("submit", function(e){
    e.preventDefault();
    hideBanner("soretFindErrorBanner");

    var orderNumber = $("soretOrderNumber").value.trim();
    var email = $("soretEmail").value.trim();

    var orderValid = ORDER_NUM_RE.test(orderNumber);
    var emailValid = EMAIL_RE.test(email);

    setInvalid("soretFieldOrderNumber", !orderValid);
    setInvalid("soretFieldEmail", !emailValid);

    if (!orderValid || !emailValid) return;

    setLoading(findBtn, true, "Searching…");

    // text/plain (not application/json) keeps this a CORS "simple
    // request" so the browser sends it straight away, no OPTIONS
    // preflight — PHP parses the same JSON body either way via
    // file_get_contents('php://input').
    fetch(FIND_ORDER_URL, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify({ order_number: orderNumber, email: email })
    })
      .then(function(res){ return res.json(); })
      .then(function(payload){
        setLoading(findBtn, false, "Find my order");
        if (!payload.success){
          showBanner("soretFindErrorBanner", payload.message ||
            "We couldn't find an order matching that number and email.");
          return;
        }
        state.order = payload.order;
        state.orderNumber = payload.order.order_number;
        console.log("payload.order ==> ",payload.order)
        populateStep2(payload.order.order_number, payload.order);
        goToStep(2);
      })
      .catch(function(){
        setLoading(findBtn, false, "Find my order");
        showBanner("soretFindErrorBanner", "Something went wrong while looking up your order. Please try again.");
      });
  });

  function populateStep2(orderNumber, record){
    $("soretOrdName").textContent = record.customer_name || "—";
    $("soretOrdDate").textContent = record.date || "—";
    $("soretOrdNumber").textContent = orderNumber;
    $("soretPhone").value = record.phone || "";

    var container = $("soretItemsContainer");
    container.innerHTML = "";
    (record.items || []).forEach(function(item){
      var row = document.createElement("div");
      row.className = "so-item-row";
      row.innerHTML =
        '<div><div class="so-name"></div><div class="so-sku"></div></div>' +
        '<div class="so-qty"></div>';
      row.querySelector(".so-name").textContent = item.name;
      row.querySelector(".so-sku").textContent = item.sku;
      row.querySelector(".so-qty").textContent = "Qty " + item.qty;
      container.appendChild(row);
    });
  }

  // ---------- STEP 2: Return details ----------
  var panel2 = $("soretPanel2");
  var submitBtn = $("soretSubmitBtn");

  $("soretBackBtn").addEventListener("click", function(){
    hideBanner("soretSubmitErrorBanner");
    goToStep(1);
  });

  // ---------- Attachments ----------
  var fileInput = $("soretAttachments");
  var fileListEl = $("soretFileList");

  fileInput.addEventListener("change", function(){
    var incoming = Array.prototype.slice.call(fileInput.files);
    hideBanner("soretFileErrorBanner");

    incoming.forEach(function(file){
      if (selectedFiles.length >= MAX_FILES){
        showBanner("soretFileErrorBanner", "You can attach up to " + MAX_FILES + " files.");
        return;
      }
      if (ALLOWED_TYPES.indexOf(file.type) === -1){
        showBanner("soretFileErrorBanner", "\"" + file.name + "\" isn't a supported file type (images or PDF only).");
        return;
      }
      if (file.size > MAX_FILE_SIZE){
        showBanner("soretFileErrorBanner", "\"" + file.name + "\" is over the 10MB limit.");
        return;
      }
      // Avoid duplicate adds (same name + size) if the user re-selects the same file
      var alreadyAdded = selectedFiles.some(function(f){
        return f.name === file.name && f.size === file.size;
      });
      if (!alreadyAdded) selectedFiles.push(file);
    });

    fileInput.value = ""; // allow re-selecting a removed file later
    renderFileList();
  });

  function renderFileList(){
    fileListEl.innerHTML = "";
    selectedFiles.forEach(function(file, index){
      var row = document.createElement("div");
      row.className = "so-file-row";

      var name = document.createElement("span");
      name.className = "so-file-name";
      name.textContent = file.name + " (" + formatFileSize(file.size) + ")";

      var removeBtn = document.createElement("button");
      removeBtn.type = "button";
      removeBtn.className = "so-file-remove";
      removeBtn.textContent = "Remove";
      removeBtn.addEventListener("click", function(){
        selectedFiles.splice(index, 1);
        renderFileList();
      });

      row.appendChild(name);
      row.appendChild(removeBtn);
      fileListEl.appendChild(row);
    });
  }

  function formatFileSize(bytes){
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + " KB";
    return (bytes / (1024 * 1024)).toFixed(1) + " MB";
  }

  panel2.addEventListener("submit", function(e){
    e.preventDefault();
    hideBanner("soretSubmitErrorBanner");

    var returnItems = $("soretReturnItems").value.trim();
    var phone = $("soretPhone").value.trim();
    var reason = $("soretReason").value;

    var itemsValid = returnItems.length > 0;
    var phoneValid = PHONE_RE.test(phone);
    var reasonValid = reason !== "";

    setInvalid("soretFieldReturnItems", !itemsValid);
    setInvalid("soretFieldPhone", !phoneValid);
    setInvalid("soretFieldReason", !reasonValid);

    if (!itemsValid || !phoneValid || !reasonValid) return;

    setLoading(submitBtn, true, "Submitting…");

    var orderRecord = state.order || {};

    // multipart/form-data is also a CORS "simple" content type, so this
    // keeps the no-preflight behavior while allowing file uploads.
    // Do NOT set a Content-Type header manually — the browser attaches
    // its own multipart boundary; setting it yourself breaks the upload.
    var formData = new FormData();
    formData.append("orderNumber", state.orderNumber);
    formData.append("email", orderRecord.email || $("soretEmail").value.trim());
    formData.append("customerName", orderRecord.customer_name || "");
    formData.append("orderDate", orderRecord.date || "");
    formData.append("items", JSON.stringify(orderRecord.items || []));
    formData.append("returnItems", returnItems);
    formData.append("phone", phone);
    formData.append("reason", reason);
    formData.append("notes", $("soretNotes").value.trim());

    selectedFiles.forEach(function(file){
      formData.append("attachments[]", file, file.name);
    });

    fetch(SUBMIT_URL, {
      method: "POST",
      body: formData
    })
      .then(function(res){ return res.json(); })
      .then(function(result){
        setLoading(submitBtn, false, "Submit return request");
        if (result.success){
          // renderResult(true, result.refId);
          renderResult(true, result.caseNumber || result.refId);
        } else {
          // If submission fails, don't lose the request — log it
          // locally so support has a record independent of whether
          // the customer calls in.
          console.error("[return-request] submission failed, logged for support follow-up:", result.message);
          renderResult(false, null);
        }
        goToStep(3);
      })
      .catch(function(err){
        setLoading(submitBtn, false, "Submit return request");
        console.error("[return-request] submission request failed:", err);
        renderResult(false, null);
        goToStep(3);
      });
  });

  // ---------- STEP 3: Confirmation ----------
 function renderResult(success, caseNumber, rmaNo){
    var block = $("soretResultBlock");
    if (success){
      block.className = "so-result so-success";
      block.innerHTML =
        '<div class="so-icon">&#10003;</div>' +
        '<h2>Return request submitted</h2>' +
        '<p>We\'ve sent your request to our customer service team and logged it in our system. You\'ll receive a confirmation email shortly with next steps.</p>' +
          '<div class="so-ref">Case No: ' + caseNumber + '</div>' + (rmaNo ? '<div class="so-ref">RMA: ' + rmaNo + '</div>' : '') +
        '<div class="so-actions">' +
          '<button type="button" class="so-btn so-btn-secondary" id="soretStartOverBtn">Start a new request</button>' +
        '</div>';
    } else {
      block.className = "so-result so-failure";
      block.innerHTML =
        '<div class="so-icon">&#33;</div>' +
        '<h2>We couldn\'t submit your return request</h2>' +
        '<p>Sorry, we couldn\'t submit your return request right now. Please visit our Contact Us page or call Customer Service so we can help you complete it.</p>' +
        '<div class="so-actions">' +
          '<a href="tel:18778228659" class="so-btn so-btn-secondary">Call 1-877-822-8659</a>' +
          '<button type="button" class="so-btn so-btn-secondary" id="soretRetryBtn">Try again</button>' +
        '</div>';
    }
    var startOver = $("soretStartOverBtn");
    if (startOver) startOver.addEventListener("click", resetForm);
    var retry = $("soretRetryBtn");
    if (retry) retry.addEventListener("click", function(){ goToStep(2); });
  }

  function resetForm(){
    findForm.reset();
    panel2.reset();
    selectedFiles = [];
    renderFileList();
    ["soretFieldOrderNumber","soretFieldEmail","soretFieldReturnItems","soretFieldPhone","soretFieldReason"].forEach(function(id){
      setInvalid(id, false);
    });
    hideBanner("soretFindErrorBanner");
    hideBanner("soretSubmitErrorBanner");
    hideBanner("soretFileErrorBanner");
    state = { order: null, orderNumber: "" };
    goToStep(1);
  }

  function setLoading(btn, loading, text){
    btn.disabled = loading;
    var span = btn.querySelector(".so-btn-text");
    if (loading){
      span.innerHTML = '<span class="so-spinner"></span> ' + text;
    } else {
      span.textContent = text;
    }
  }

  // Clear inline errors as the person types/selects
  $("soretOrderNumber").addEventListener("input", function(){ setInvalid("soretFieldOrderNumber", false); });
  $("soretEmail").addEventListener("input", function(){ setInvalid("soretFieldEmail", false); });
  $("soretReturnItems").addEventListener("input", function(){ setInvalid("soretFieldReturnItems", false); });
  $("soretPhone").addEventListener("input", function(){ setInvalid("soretFieldPhone", false); });
  $("soretReason").addEventListener("change", function(){ setInvalid("soretFieldReason", false); });

  // ---------- Init ----------
  var urlOrderId = getOrderIdFromUrl();
  console.log("[return-request] detected order id from URL:", urlOrderId);
  if (urlOrderId) {
    autoLoadOrderById(urlOrderId);
  }

})();